import { smartDevicePopupLink } from './url';

interface IExtraField {
    type: string;
    name: string;
    defaultValue?: string;
    data?: any[];
}
interface IEmailMap {
    [key: string]:
        | {
              type: 'klaviyo';
              list_id: string;
              source: string;
              consent_form_id: string;
              popupBtnLink: string;
              SmartDevices?: string;
          }
        | {
              type: 'mailchimp';
              action: string;
              extraFields?: IExtraField[];
              popupBtnLink: string;
          };
}

// us,ca,eu,uk,de,fr,it,es 时间一样
const TimeLineProd: any = {
    teaser: '2023/04/19 16:00:00 GMT+8',
    detail: '2023/04/26 15:00:00 GMT+8',
    shopify: {
        // us/ca 时间从2023/05/15 15:00 改为 21:00 （@陈琨 05/15 18:00）
        us: '2023/05/15 21:00:00 GMT+8',
        ca: '2023/05/15 21:00:00 GMT+8',
        uk: '2023/05/15 21:00:00 GMT+8',
        eu: '2023/05/15 21:00:00 GMT+8',
        de: '2023/05/15 21:00:00 GMT+8',
        fr: '2023/05/15 21:00:00 GMT+8',
        it: '2023/05/15 21:00:00 GMT+8',
        es: '2023/05/15 21:00:00 GMT+8',
    },
};

const TimeLineTest: any = {
    teaser: '2023/04/19 16:00:00 GMT+8',
    detail: '2023/04/21 17:30:00 GMT+8',
    shopify: {
        us: '2023/04/26 16:10:00 GMT+8',
        ca: '2023/04/26 15:52:00 GMT+8',
        uk: '2023/04/25 21:00:00 GMT+8',
        eu: '2023/04/25 21:00:00 GMT+8',
        de: '2023/04/25 21:00:00 GMT+8',
        fr: '2023/04/25 21:00:00 GMT+8',
        it: '2023/04/25 21:00:00 GMT+8',
        es: '2023/04/25 21:00:00 GMT+8',
    },
};

export const getSamrtDevicesTimeline = (flag: boolean) => (flag ? TimeLineTest : TimeLineProd);

export const emailMap: IEmailMap = {
    us: {
        type: 'klaviyo',
        list_id: 'XwtFqF',
        source: 'EcoFlow Smart Devices Teaser from',
        consent_form_id: 'RYAKww',
        popupBtnLink: smartDevicePopupLink.blade,
    },
    ca: {
        type: 'klaviyo',
        list_id: 'XdbY9J',
        source: 'EcoFlow Smart Devices Teaser from',
        consent_form_id: 'S586gv',
        popupBtnLink: smartDevicePopupLink.blade,
    },
    eu: {
        type: 'klaviyo',
        list_id: 'YhePMF',
        source: 'EcoFlow Smart Devices Teaser from',
        consent_form_id: 'XqVgbe',
        popupBtnLink: smartDevicePopupLink.blade,
    },
    uk: {
        type: 'klaviyo',
        list_id: 'VsQKN6',
        source: 'EcoFlow Smart Devices Teaser from',
        consent_form_id: 'RRauHj',
        popupBtnLink: smartDevicePopupLink.blade,
    },
    de: {
        type: 'klaviyo',
        list_id: 'U3U9SX',
        source: 'EcoFlow Smart Devices Teaser from',
        consent_form_id: 'UiYqZR',
        popupBtnLink: smartDevicePopupLink.de,
    },
    fr: {
        type: 'klaviyo',
        list_id: 'UWAHEQ',
        source: 'EcoFlow Smart Devices Teaser from',
        consent_form_id: 'Y2fcvh',
        popupBtnLink: smartDevicePopupLink.fr,
    },
    it: {
        type: 'klaviyo',
        list_id: 'SNPiGY',
        source: 'EcoFlow Smart Devices Teaser from',
        consent_form_id: 'YfittE',
        popupBtnLink: smartDevicePopupLink.blade,
    },
    es: {
        type: 'klaviyo',
        list_id: 'YbgtaC',
        source: 'EcoFlow Smart Devices Teaser from',
        consent_form_id: 'WprPGv',
        popupBtnLink: smartDevicePopupLink.blade,
    },
    jp: {
        type: 'mailchimp',
        action: 'https://ecoflow.us8.list-manage.com/subscribe/post?u=d002bf04842356c4c1c5221cf&amp;id=440b6cbd62&amp;f_id=00b372e1f0',
        popupBtnLink: smartDevicePopupLink.jp,
    },
};

export const popupBtnLinkMap: any = {
    us: {
        link1: smartDevicePopupLink.blade,
        link2: smartDevicePopupLink.glacierWave,
    },
    de: {
        link1: smartDevicePopupLink.de,
        link2: smartDevicePopupLink.de,
    },
    fr: {
        link1: smartDevicePopupLink.fr,
        link2: smartDevicePopupLink.fr,
    },
    jp: {
        link1: smartDevicePopupLink.jp,
        link2: smartDevicePopupLink.jp,
    },
};

export const scrollToLive = (dom: HTMLDivElement, query: string | undefined | null | string[], offset: number): void => {
    if (dom && query === '1') {
        const rect = dom.getBoundingClientRect();
        window.scrollTo({ top: Math.floor(rect.top) - offset, behavior: 'smooth' });
    }
};
